module.exports = __webpack_public_path__ + "img/ticket_button_normal@2x.353355d3.png";